import React from "react"
import { FaBars } from "react-icons/fa"
import { useHistory } from "react-router-dom"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import classes from "./ShiftCashierHistoryTopbar.module.scss"

const ShiftCashierHistoryTopbar = props => {
  const { setOpenShiftHistorySidebar } = props

  const [t, i18n] = useTranslation()

  const history = useHistory()

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <div className={classes["container"]}>
      <button
        id="shift-cashier-hamburger-button"
        className={classes["button"]}
        onClick={() => setOpenShiftHistorySidebar(prev => !prev)}
      >
        <FaBars
          size={20}
          color="white"
        />
      </button>

      <button
        className={clsx(
          classes["back"],
          isLtr && classes["back-rtl"]
        )}
        onClick={() => history.goBack()}
      >
        {t("بازگشت")}
      </button>
    </div>
  )
}

export default ShiftCashierHistoryTopbar